import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {UserService} from "../../../../@shared/services/user.service";
import {Subject} from "rxjs";
import * as moment from 'moment';
import {takeUntil} from "rxjs/operators";
import {LineChartComponent} from "@swimlane/ngx-charts";
import {
  ICommonStat,
  IProfitByCase,
  IProfitByCaseBattle,
  IProfitByGame
} from "../services/interfaces/common-stats.interface";
import {LogType} from "../../../../@core/enums/log-type.enum";
import {environment} from "../../../../../environments/environment";
import {MatSort} from "@angular/material/sort";

@Component({
  selector: 'app-common-stats',
  templateUrl: './common-stats.component.html',
  styleUrls: ['./common-stats.component.scss']
})
export class CommonStatsComponent implements OnDestroy, AfterViewInit {
  @ViewChild('chart') chart: LineChartComponent;

  @ViewChild('matSortProbableGamingIncome', {read: MatSort, static: true}) matSortProbableGamingIncome: MatSort;
  @ViewChild('matSortCase', {read: MatSort, static: true}) matSortCase: MatSort;
  @ViewChild('matSortCaseBattles', {read: MatSort, static: true}) matSortCaseBattles: MatSort;
  @ViewChild('matSortGames', {read: MatSort, static: true}) matSortGames: MatSort;

  public isGoFast: boolean = environment.projectName === 'CSGOFAST';

  public sort: any;
  public isLoading: boolean = true;
  private readonly destroyed$: Subject<void> = new Subject();

  public selectedDate: any;
  public logType = LogType;
  public statByGameColumns = ['count', 'type', 'agentKey', 'total'];
  public statByGameDataSource: MatTableDataSource<IProfitByGame> = new MatTableDataSource();

  public statByCaseColumns = ['row', 'name', 'count', 'bets', 'wons', 'profit'];
  public statByCaseDataSource: MatTableDataSource<IProfitByCase> = new MatTableDataSource();

  public statByCaseBattlesColumns = ['row', 'name', 'count', 'bets', 'wons', 'profit'];
  public statByCaseBattlesDataSource: MatTableDataSource<IProfitByCaseBattle> = new MatTableDataSource();

  public probableIncomeColumns = ['count', 'game', 'income'];
  public probableIncomeDataSource: MatTableDataSource<any> = new MatTableDataSource<any>();


  constructor(private userService: UserService) {
    this.subscribeEmitters();
  }


  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngAfterViewInit() {
    this.probableIncomeDataSource.sort = this.matSortProbableGamingIncome;
    this.statByGameDataSource.sort = this.matSortGames;

    this.statByCaseDataSource.sort = this.matSortCase;
    this.statByCaseBattlesDataSource.sort = this.matSortCaseBattles;
  }

  public convertDataForChart(data: any): any {
    if (!data.balanceGraph.length) {
      return [{name: 'Balance', series: [{name: moment().format('L'), value: 0}]}]
    }

    const graphData = data.balanceGraph.map((dataItem: any) => {
      return {
        name: new Date(dataItem.createdAt),
        value: dataItem.balance / 100
      }
    })

    return [{name: 'Balance', series: graphData}]
  }

  refreshTimeline(chart: LineChartComponent) {
    chart.filteredDomain = null;
    // Chart HTML element
    // @ts-ignore
    const chartElement: any = chart['nativeElement'];
    // Two lines at first and end of the selection box should be disappeared
    chartElement.querySelector('rect.handle.handle--w')?.setAttribute('style', 'width:0px');
    chartElement.querySelector('rect.handle.handle--e')?.setAttribute('style', 'width:0px');
    // Selection box HTML element
    const timelineSelectionElement: HTMLElement | null = chartElement.querySelector('rect.selection');
    // Selection box should be disappeared
    timelineSelectionElement?.style.setProperty('width', '0');
    // Timeline HTML element
    const timelineElement: HTMLElement | null = chartElement.querySelector('g.brush');
    // Next time that a user clicked on the timeline element, remove all hidden property which are set manually
    timelineElement?.addEventListener('mousedown', (event: MouseEvent) => {
      // Only when left button is clicked
      if (event.button == 0) {
        (<HTMLElement>(<HTMLElement>event.currentTarget).querySelector('rect.selection'))?.style.removeProperty('width');
        (<HTMLElement>(<HTMLElement>event.currentTarget).querySelector('rect.handle.handle--w'))?.style.removeProperty('width');
        (<HTMLElement>(<HTMLElement>event.currentTarget).querySelector('rect.handle.handle--e'))?.style.removeProperty('width');
      }
    });
  }

//

  public changeDateFilter(filter: any): void {
    this.isLoading = true;
    this.selectedDate = filter;
    this.userService.requestCommonStat(filter);
  }

  private subscribeEmitters(): void {
    this.userService.commonStat$
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((commonStats: ICommonStat) => {
        this.statByGameDataSource.data = commonStats.profitByGames;
        this.statByCaseDataSource.data = commonStats.profitByCases;
        this.statByCaseBattlesDataSource.data = commonStats.profitByBattlesCases;
        const upData = Object.keys(commonStats.statistics.up)
          .map((key: string) => ({game: key, income: commonStats.statistics.up[key]}));
        this.probableIncomeDataSource.data = upData;
        this.isLoading = false;
      })
  }
}
